import React, { useState } from 'react';
import { Dialog, DialogActions, DialogContent, DialogTitle, Button, TextField, Typography,
  Snackbar,
  Alert, } from '@mui/material';
import axios from 'axios';
import env from "react-dotenv";

const AddMachineList = ({ open, handleClose, fetchMachines }) => {
  const [machineNo, setMachineNo] = useState('');
  const [machineName, setMachineName] = useState('');
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');
  const [productId, setProductId] = useState('');

  const handleAddMachine = () => {
    const newMachine = {
      MachineNo: machineNo,
      MachineName: machineName,
      startDate: startDate,
      endDate: endDate,
      productId: productId,
    };

    axios
      .post(`${process.env.REACT_APP_PJCBACKEND_URL}/api/machinelist`, newMachine)
      .then((response) => {
        fetchMachines();  // Refresh the machine list after adding
        handleClose();    // Close the dialog
      })
      .catch((error) => console.error('Error adding machine:', error));
  };

  return (
    <Dialog open={open} onClose={handleClose} fullWidth maxWidth="sm">
      <DialogTitle>
      <Typography variant="h6" align="center" gutterBottom>
        Add New Machine
        </Typography>
        </DialogTitle>
      <DialogContent dividers>
        <TextField
          label="Machine ID"
          fullWidth
          value={machineNo}
          onChange={(e) => setMachineNo(e.target.value)}
          margin="normal"
        />
        <TextField
          label="Machine Name"
          fullWidth
          value={machineName}
          onChange={(e) => setMachineName(e.target.value)}
          margin="normal"
        />
        <TextField
          label="Start Date"
          fullWidth
          type="datetime-local"
          value={startDate}
          onChange={(e) => setStartDate(e.target.value)}
          margin="normal"
          InputLabelProps={{
            shrink: true,
          }}
        />
        <TextField
          label="End Date"
          fullWidth
          type="datetime-local"
          value={endDate}
          onChange={(e) => setEndDate(e.target.value)}
          margin="normal"
          InputLabelProps={{
            shrink: true,
          }}
        />
        <TextField
          label="Product ID"
          fullWidth
          value={productId}
          onChange={(e) => setProductId(e.target.value)}
          margin="normal"
        />
      </DialogContent>
      <DialogActions sx={{ justifyContent: 'center' }}>
        <Button onClick={handleClose} color="secondary">
          Cancel
        </Button>
        <Button onClick={handleAddMachine} color="primary">
          Save
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default AddMachineList;
